import type { ReactNode } from 'react'
import type { IconKey } from './screens'

type ShellIcon = IconKey | 'plus' | 'search' | 'chevron-left' | 'chevron-right'

const PATHS: Record<ShellIcon, ReactNode> = {
  home: (
    <>
      <path d="M3 9.5 9 4l6 5.5V15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" />
      <path d="M7.5 16v-3.5h3V16" />
    </>
  ),
  people: (
    <>
      <circle cx="7" cy="6.5" r="2.5" />
      <path d="M2.5 15.5c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5" />
      <path d="M12 4.2a2.5 2.5 0 0 1 0 4.6M13.5 11.3c1.3.6 2 2.2 2 4.2" />
    </>
  ),
  deals: <path d="M3 4h12l-4.5 5.5V14L7.5 12V9.5L3 4z" />,
  inbox: (
    <>
      <rect x="2.5" y="5" width="13" height="9" rx="1" />
      <path d="M2.5 5 9 10l6.5-5" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="5" width="12" height="10" rx="1" />
      <path d="M3 8.5h12M6 3.5v2M12 3.5v2" />
    </>
  ),
  plus: <path d="M9 4v10M4 9h10" />,
  search: (
    <>
      <circle cx="8" cy="8" r="4.5" />
      <path d="M11.5 11.5 15 15" />
    </>
  ),
  'chevron-left': <path d="M11 4l-5 5 5 5" />,
  'chevron-right': <path d="M7 4l5 5-5 5" />,
}

export function Icon({ name, size = 18 }: { name: ShellIcon; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name]}
    </svg>
  )
}
